module.exports = __webpack_public_path__ + "img/lambus_pro_header.04ce4fb.png";